import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CaptchaImage from './Instruments/CaptchaImage'
import HomeBtn from './Instruments/HomeBtn'
import ThrowError from './Instruments/TrowError';
import translate from './../../Translate/resetPassword.json';
import { resetRequest } from '../../../shared/service';

const ChangePasswordLogin = () => {
    const navigate = useNavigate();
    const [language, setLanguage] = useState('');
    useEffect(() => {
      setLanguage(JSON.parse(localStorage.getItem('choosen-language')));
    }, [])

    const [currentPass, setCurrentPass] = useState('');
    const [errorCurrent, setErrorCurrent] = useState('');

    const [captchaForm, setCaptchaForm] = useState('');
    const [errorCaptcha, setErrorCaptcha] = useState(false);

    const handleCaptchaFormChange = (e) => {
        setCaptchaForm(e.target.value);
    }
    const handleForm2Change = (e) => {
        setCurrentPass(e.target.value);
    }
    async function checkCaptcha() {
        const id = localStorage.getItem('captcha')
        try {
          await resetRequest({ email: currentPass, captchaId: id, captchaReply: captchaForm });
          localStorage.setItem('captcha', '');
          navigate('/login');
        } catch (error) {
          console.error('Ошибка при запросе к API:', error);
          setErrorCaptcha(true);
        }
      }

    const handleCheckButton = () => {
        let isValidForm2 = true;
        if (currentPass === '') {
            isValidForm2 = false;
            setErrorCurrent('Complete the form');
        } else {
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (!emailPattern.test(currentPass)) {
                isValidForm2 = false;
                setErrorCurrent('Not an email');
            }else {
                setErrorCurrent('');
            }
        }
        console.log(captchaForm)
        if(isValidForm2){
            checkCaptcha();
        }
    }
  return(
    <div>
      <div className='main for-log'>
        {errorCaptcha && <ThrowError message={""}/>}
        <HomeBtn/>
        <div className='log'>
          <div className='logs'>
            <h2 className='main-pages-titles'>{translate.reset.title[language]}</h2>
            <p className='inputs'>
            <input type="text"  className='form' placeholder={translate.reset.placeholder1[language]} value={currentPass} onChange={handleForm2Change} />
            </p>
            {errorCurrent && <p className="error-message">{errorCurrent}</p>}
            <CaptchaImage/>
            <p>
            <input type="text" className='form' placeholder={translate.reset.placeholder2[language]} value={captchaForm} onChange={handleCaptchaFormChange} />
            </p>
            <p>{translate.reset.prase1[language]}</p>
            <div className='log-container'>
              <button className='grid-log login-accept-btn' onClick={() => {handleCheckButton()}}>{translate.reset.button1[language]}</button> 
              <button className='grid-log register-route-btn' onClick={() => {navigate('/login')}}>{translate.reset.button2[language]}</button> 
            </div>       
          </div>
        </div> 
      </div> 
    </div>
  )
}

export default ChangePasswordLogin;
